import type { Component } from "solid-js";
import { twMerge } from "tailwind-merge";

export const ProgressBar: Component<{ percentage: number }> = (props) => {
	return (
		<div class="relative h-2 w-full">
			<div class="absolute inset-0 rounded-full bg-interaction-grey-light" />
			<div
				class={twMerge(
					"absolute top-0 left-0 h-2 rounded-full bg-interaction-violet",
					props.percentage <= 10 && "bg-status-accent-error"
				)}
				style={{ width: `${props.percentage}%` }}
			/>
		</div>
	);
};
